/* dynamic-layout.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./dynamic-layout.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { parseDynamicLayoutOutputToJson } from './dynamic-layout-parser/dynamic-layout-parser';
import { DynamicLayoutSections } from './ui/section/dynamic-layout-sections';
var styles = {
  containerStyles: "_y3gn1e5h _otyrpxbi"
};
export var DynamicLayout = function DynamicLayout(_ref) {
  var contentToRender = _ref.contentToRender;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    parsedAnswer = _useState2[0],
    setParsedData = _useState2[1];
  useEffect(function () {
    if (contentToRender) {
      var res = parseDynamicLayoutOutputToJson(contentToRender);
      if (res && res.length > 0) {
        setParsedData(res);
      }
    }
  }, [contentToRender]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.containerStyles
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.300"
  }, parsedAnswer && parsedAnswer.length && parsedAnswer.map(function (section) {
    return /*#__PURE__*/React.createElement(DynamicLayoutSections, {
      section: section
    });
  })));
};